module.exports = __webpack_public_path__ + "media/images/banner-f11a966c.svg";